import Vue from "vue";
import App from "./App";
import store from "@/store";
import { router } from "./router";
// import adminTemplates from "@/pages/router"; //用户后台菜单

import * as filters from "@/filters";

// import Config from "./config";
import { sync } from "vuex-router-sync";
import ElementUI from "element-ui";
import "@/styles/main.scss";
import "@/styles/element-variables.scss";
import _ from "lodash";
import "splitpanes/dist/splitpanes.css";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

import lottie from "vue-lottie";
Vue.component("lottie", lottie);

Vue.prototype._ = _;
Vue.component("VueSlider", VueSlider);
// register global utility filters.
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});

// 全局素材文件，挂载到实例对象属上面
// const templates = {
// ...adminTemplates,
// ...pages
// };
// Vue.prototype.$templates = templates
// store.commit("SET_TEMPLATES", { templates, name: Config.name });
// store.commit("SET_$ROUTER", routers);

// vue.min.js引进的devtools 默认为false
Vue.config.devtools = true;
Vue.config.productionTip = false;
// Vue.use(Loading.directive)

Vue.use(ElementUI, {
  // size: "small"
});

sync(store, router);

new Vue({
  el: "#app",
  store,
  router,
  render: (createElement) => createElement(App)
});
